export default "__VITE_ASSET__4HXkKNQt__"